<template>
    <div
        v-if="enabled"
        id="lipscore-rating"
        style="display: none !important"
        :data-ls-product-name="productName"
        :data-ls-brand="brand ?? undefined"
        :data-ls-product-id="productId ?? undefined"
        :data-ls-product-url="productUrl ?? undefined"
        :data-ls-sku="sku ?? undefined"
        :data-ls-description="description ?? undefined"
        :data-ls-image-url="imageUrl ?? undefined"
        :data-ls-price="price ?? undefined"
        :data-ls-price-currency="priceCurrency ?? undefined"
        :data-ls-category="category ?? undefined"
        :data-ls-mpn="mpn ?? undefined"
        :data-ls-gtin="gtin ?? undefined"
    />
</template>

<script setup lang="ts">
import { refreshLipscoreWidgets } from '@/composables/useLipscoreWidgetScript';
import type { AppPageProps } from '@/types';
import { usePage } from '@inertiajs/vue3';
import { computed, onMounted, watch } from 'vue';

const props = defineProps<{
    productName: string;
    productId: string | null;
    brand?: string | null;
    productUrl?: string | null;
    sku?: string | null;
    description?: string | null;
    imageUrl?: string | null;
    price?: number | null;
    priceCurrency?: string | null;
    category?: string | null;
    mpn?: string | null;
    gtin?: string | null;
}>();

// Hidden container, still required by Lipscore: `!important` beats its own `.lipscore-rating { display: table }`.
const lipscore = computed(() => usePage<AppPageProps>().props.lipscore);
const enabled = computed(() => lipscore.value?.enabled ?? false);

// Trigger re-init when the deferred prop lands or when the product changes.
onMounted(triggerRefresh);
watch([enabled, () => props.productId], triggerRefresh);

function triggerRefresh(): void {
    if (!enabled.value) {
        return;
    }

    void refreshLipscoreWidgets();
}
</script>
